import React from 'react'
import CanvasLogo from '../../../assets/icons/canvas-logo.svg'
import SuspensionModal from './SuspensionModal'
import { LevelTrackerSection, RequirementsSection } from './ProgressTrackerContent'
import {
  Container,
  SuspendedContentWrapper,
  DisabledOverlay,
  Header,
  Title,
  AssociateHeader,
  Divider,
  ProgramInfoItem,
  ProgramInfoLabel,
  ProgramInfoLink,
  PortalButton,
  PortalButtonText
} from './Styles/ProgressTracker.styles'

const SuspendedProgressTracker = ({
  levels,
  enrollmentDate,
  currentLevel,
  levelCompletionDate,
  patRequirementWithWarning,
  additionalRequirements,
  activeLevel,
  shouldShowPATWarning,
  shouldShowLevelCompleteBanner,
  shouldShowAdditionalRequirements,
  onLevelClick
}) => {
  return (
    <Container>
      <Header>
        <Title>My Path to Membership</Title>
        {!!enrollmentDate && (
          <AssociateHeader>
            <ProgramInfoItem>
              <ProgramInfoLabel>Associate Program</ProgramInfoLabel>
              <ProgramInfoLink>Details ›</ProgramInfoLink>
            </ProgramInfoItem>
            <Divider />
            <ProgramInfoItem>
              <ProgramInfoLabel>Enrolled: {enrollmentDate}</ProgramInfoLabel>
              <ProgramInfoLink>Guidelines ›</ProgramInfoLink>
            </ProgramInfoItem>
          </AssociateHeader>
        )}
      </Header>

      <SuspendedContentWrapper>
        <DisabledOverlay>
          <LevelTrackerSection 
            levels={levels}
            isSuspended
          />
        </DisabledOverlay>

        <DisabledOverlay>
          <RequirementsSection
            shouldShowLevelCompleteBanner={shouldShowLevelCompleteBanner}
            currentLevel={currentLevel}
            levelCompletionDate={levelCompletionDate}
            patRequirementWithWarning={patRequirementWithWarning}
            additionalRequirements={additionalRequirements}
            activeLevel={activeLevel}
            shouldShowPATWarning={shouldShowPATWarning}
            shouldShowAdditionalRequirements={shouldShowAdditionalRequirements}
            onLevelClick={onLevelClick}
          />
        </DisabledOverlay>

        <SuspensionModal />
      </SuspendedContentWrapper>

      <PortalButton>
        <img src={CanvasLogo} alt="Canvas Logo" />
        <PortalButtonText>Education Portal</PortalButtonText>
      </PortalButton>
    </Container>
  )
}

export default SuspendedProgressTracker

